import { AppComm } from "../models/api/AppComm";
import { AppCommType } from "../models/api/AppCommType";
import { rootStore } from "../StApp";
import NotificationHandlerService from "./NotificationHandlerService";

class AppCommHandlerService {

    handleComm(appComm: AppComm) {
        switch (appComm.type) {
            case AppCommType.NEW_MATCH:
                rootStore.matchStore.loadNewMatches(true)
                break;

            case AppCommType.POT_MATCH:
                rootStore.matchStore.loadPotMatches(true)
                break;

            case AppCommType.SAY_HELLO:
                rootStore.imChatListStore.loadConversedMatches(true)
                break;
        }

        NotificationHandlerService.handleAppComm(appComm.type)
    }
}

export default new AppCommHandlerService